import React from "react";
import { Row, Col, Button } from "reactstrap";
import { Icon } from "@material-ui/core";
import InputFeild from "../../../global/form/input";
import SelectList from "../../../global/form/select";
import { FieldLabel, TagListInput, IconButton, SectionPanel, NestedRow } from "./common_controls";
import { TRANSFORM_TYPES, splitIdentifierColumns, joinIdentifierColumns } from "./config_model";

const TransformStepRow = ({ step, onChange, onRemove }) => (
  <NestedRow className="align-items-center">
    <Col xs={4}>
      <SelectList value={step.type || ""} onChange={e => onChange({ type: e.target.value })}>
        {TRANSFORM_TYPES.map(t => (
          <option key={t.value} value={t.value}>{t.label}</option>
        ))}
      </SelectList>
    </Col>
    {step.type === "regex" && (
      <>
        <Col xs={5}>
          <InputFeild placeholder="Pattern e.g. [0-9]+" value={step.regex || ""} onChange={e => onChange({ regex: e.target.value })} />
        </Col>
        <Col xs={2}>
          <InputFeild type="number" placeholder="Match #" value={step.index || 0} onChange={e => onChange({ index: Number(e.target.value) })} />
        </Col>
      </>
    )}
    {step.type === "split" && (
      <>
        <Col xs={4}>
          <InputFeild placeholder="Separator e.g. _" value={step.separator || ""} onChange={e => onChange({ separator: e.target.value })} />
        </Col>
        <Col xs={3}>
          <InputFeild type="number" placeholder="Part #" value={step.index || 0} onChange={e => onChange({ index: Number(e.target.value) })} />
        </Col>
      </>
    )}
    {step.type === "replace" && (
      <>
        <Col xs={3}>
          <InputFeild placeholder="Find" value={step.str || ""} onChange={e => onChange({ str: e.target.value })} />
        </Col>
        <Col xs={4}>
          <InputFeild placeholder="Replace with" value={step.val || ""} onChange={e => onChange({ val: e.target.value })} />
        </Col>
      </>
    )}
    <Col xs="auto" className="ml-auto">
      <IconButton icon="delete" danger onClick={onRemove} title="Remove step" />
    </Col>
  </NestedRow>
);

const IdentifierSection = ({ config, onChange }) => {
  const setField = (key, value) => onChange({ ...config, [key]: value });

  const updateStep = (index, patch) => {
    const steps = [...config.identifierConfiguration];
    steps[index] = { ...steps[index], ...patch };
    setField("identifierConfiguration", steps);
  };
  const removeStep = index => setField("identifierConfiguration", config.identifierConfiguration.filter((_, i) => i !== index));
  const addStep = () => setField("identifierConfiguration", [...config.identifierConfiguration, { type: "regex", regex: "", index: 0 }]);

  return (
    <SectionPanel title="Identifier & Matching">
      <FieldLabel label="Match incoming report rows by" helper="How should a row in the client's report be matched to an existing task?">
        <Row noGutters>
          <Col xs="auto" className="mr-2">
            <Button size="sm" className={Number(config.identifier) === 0 ? "buttonred" : "button_outline"} onClick={() => setField("identifier", 0)}>
              Reference ID
            </Button>
          </Col>
          <Col xs="auto">
            <Button size="sm" className={Number(config.identifier) === 1 ? "buttonred" : "button_outline"} onClick={() => setField("identifier", 1)}>
              Mobile Number
            </Button>
          </Col>
        </Row>
      </FieldLabel>

      <FieldLabel label="Identifier column(s) in the report" helper="The column name(s) exactly as they appear in the client's file. If more than one, values are combined.">
        <TagListInput
          values={splitIdentifierColumns(config.identifier_column)}
          onChange={arr => setField("identifier_column", joinIdentifierColumns(arr))}
          placeholder="e.g. APPLICATION_REFERENCE_NUMBER"
        />
      </FieldLabel>

      {Number(config.identifier) === 1 && (
        <FieldLabel label="Mobile number input ID" helper="The task form's input ID that stores the mobile number (defaults to 1 if left blank).">
          <InputFeild type="number" placeholder="1" value={config.identifier_input_id || ""} onChange={e => setField("identifier_input_id", e.target.value ? Number(e.target.value) : "")} />
        </FieldLabel>
      )}

      <FieldLabel label="Clean up the identifier before matching" helper="Optional steps to strip prefixes or extract the useful part of the identifier, applied in order.">
        {(config.identifierConfiguration || []).map((step, i) => (
          <TransformStepRow key={i} step={step} onChange={patch => updateStep(i, patch)} onRemove={() => removeStep(i)} />
        ))}
        <Button size="sm" color="link" className="p-0 mt-1" onClick={addStep}><Icon fontSize="small" className="align-middle">add</Icon> Add cleanup step</Button>
      </FieldLabel>
    </SectionPanel>
  );
};

export default IdentifierSection;
